import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  radioGroup: {
    width: '100%',
    '.ant-radio': {
      '+span': {
        width: 'inherit'
      }
    }
  },

  cardRoot: {
    height: '100%'
  },

  cardBody: {
    padding: 0 + '!important',
    display: 'flex',
    height: '100%',
    alignItems: 'center'
  },

  radio: {
    padding: 12,
    width: '100%'
  }
}))
